/**
 * Collection Carousel section.
 * Handles product card interactions (swatches, quick-add to cart).
 */
/**
 * Collection Carousel section.
 * Card interactions (swatches, quick-add) handled by delegated product-card.js.
 */
class CollectionCarousel extends HTMLElement {
  connectedCallback() {
    // All card interactions handled globally by product-card.js
  }
}

function relocateLookfyGalleryIntoCollectionDescription() {
  const slot = document.querySelector("[data-lookfy-slot]");
  const mainSection = document.querySelector("#shopify-section-main");
  const gallerySection = mainSection?.nextElementSibling;

  if (!slot || !gallerySection || slot.contains(gallerySection)) return;

  slot.appendChild(gallerySection);
}

function initLookfyGalleryRelocation() {
  relocateLookfyGalleryIntoCollectionDescription();

  document.addEventListener(
    "shopify:section:load",
    relocateLookfyGalleryIntoCollectionDescription,
  );
  document.addEventListener(
    "shopify:section:reorder",
    relocateLookfyGalleryIntoCollectionDescription,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLookfyGalleryRelocation, {
    once: true,
  });
} else {
  initLookfyGalleryRelocation();
}

customElements.define("collection-carousel", CollectionCarousel);

export { CollectionCarousel };
